<apex-box
  class="no-padding"
  icon="groups"
  [expanded]="true">
  <T
    title
    str="Tenants"></T>

  <div
    *ngIf="loadingTenants"
    class="df ac jc ams">
    <mat-spinner [diameter]="32"></mat-spinner>
  </div>

  <div
    *ngIf="!loadingTenants && availableTenants.length === 0"
    class="df c apl apt aprs">
    <div class="amb mat-body-2">
      <T str="No tenants"></T>
    </div>
  </div>

  <div
    *ngIf="!loadingTenants && availableTenants.length > 0"
    class="df c apl apt aprs">
    <div
      *ngFor="let tenant of availableTenants"
      class="df ac jsb amb">
      <div class="df ac f1">
        <mat-icon class="amr">person</mat-icon>
        <div class="df c">
          <div class="mat-body-1">
            {{ tenant.CRMUser?.name || tenant.User?.name || 'Unknown' }} - {{ tenant.translatedRole }}
          </div>
          <div
            class="mat-caption"
            *ngIf="tenant.from">
            {{ tenant.from | date: 'shortDate' }} - {{ tenant.to | date: 'shortDate' }}
          </div>
        </div>
      </div>
      <button
        mat-icon-button
        color="primary"
        [disabled]="disabled || isTenantAlreadyInvolved(tenant)"
        (click)="openAddTenantDialog(tenant)"
        [matTooltip]="
          isTenantAlreadyInvolved(tenant) ? ('Already involved' | translate) : ('Add as involved' | translate)
        ">
        <mat-icon>{{ isTenantAlreadyInvolved(tenant) ? 'check_circle' : 'add_circle' }}</mat-icon>
      </button>
    </div>
  </div>
</apex-box>
